export const searchInObject = (obj: any, value: string) => {
  try {
    if (!obj) {
      return false;
    }
    if (typeof obj !== "object") {
      return false;
    }
    return (
      Object.values(obj)
        .filter((v) => v && (typeof v === "string" || typeof v === "number"))
        .filter((v) => `${v}`.toLowerCase().includes(value?.toLowerCase()))
        ?.length > 0
    );
  } catch (e) {
    return false;
  }
};
